import { useEffect } from 'react';
import { Platform } from 'react-native';

interface DynamicTitleProps {
  title?: string;
  environment?: 'production' | 'staging' | 'development';
}

export const DynamicTitle: React.FC<DynamicTitleProps> = ({
  title = 'As Gastronomico',
  environment = 'production',
}) => {
  useEffect(() => {
    if (
      Platform.OS !== 'web' ||
      typeof document === 'undefined' ||
      typeof window === 'undefined' ||
      !window.location
    ) {
      return;
    }

    let finalTitle = title;
    const host = window.location.hostname;

    const isStaging =
      host.includes('staging') || host.includes('d1vqfq5zg') || host.includes('preview');

    const isDevelopment = host.includes('localhost') || host.includes('192.168.0.101');

    if (isStaging) {
      finalTitle = `(staging) ${title}`;
    } else if (isDevelopment) {
      finalTitle = `(dev) ${title}`;
    }

    document.title = finalTitle;
  }, [title, environment]);

  return null; // Este componente no renderiza nada visual
};
